import { privateClient } from "@/api/privateClient";
import { SUPER_ADMIN_ENDPOINTS } from "../../endpoint";
import type { RecentActivity, SuperAdminStats } from "../types";

export const getSuperAdminStats = async (): Promise<SuperAdminStats> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.DASHBOARD.STATS);
  return data.stats;
};

export const getRecentActivity = async (): Promise<RecentActivity> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.DASHBOARD.RECENT);
  return data;
};